module.exports = __webpack_public_path__ + "img/profile.67d313f1.png";